"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listVpcs = void 0;
const listVpcs = ({ httpClient, }) => ({ page = 1, per_page = 25, }) => {
    const path = '/vpcs';
    const query_params = { page, per_page };
    const url = `${path}`;
    return httpClient.get(url, { params: query_params });
};
exports.listVpcs = listVpcs;
//# sourceMappingURL=list-vpcs.js.map